var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotationLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 10.25C19.75 15.4967 15.4967 19.75 10.25 19.75C5.00334 19.75 0.75 15.4967 0.75 10.25C0.75 5.00329 5.00334 0.75 10.25 0.75C14.1456 0.75 17.4936 3.09478 18.9595 6.45M19.75 3.75L19.275 6.925L16.25 6.25",
    stroke: "#123B6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.25V7.75C8.25 6.64543 9.14543 5.75 10.25 5.75C11.3546 5.75 12.25 6.64543 12.25 7.75V9.25M9.5 14.75H11C12.1728 14.75 12.7592 14.75 13.1631 14.44C13.2671 14.3602 13.3602 14.2671 13.44 14.1631C13.75 13.7592 13.75 13.1728 13.75 12C13.75 10.8272 13.75 10.2408 13.44 9.83686C13.3602 9.73286 13.2671 9.63977 13.1631 9.55997C12.7592 9.25 12.1728 9.25 11 9.25H9.5C8.32721 9.25 7.74082 9.25 7.33686 9.55997C7.23286 9.63977 7.13977 9.73286 7.05997 9.83686C6.75 10.2408 6.75 10.8272 6.75 12C6.75 13.1728 6.75 13.7592 7.05997 14.1631C7.13977 14.2671 7.23286 14.3602 7.33686 14.44C7.74082 14.75 8.32721 14.75 9.5 14.75Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotationLock);
export default __webpack_public_path__ + "static/media/rotation-lock.25a3e57e253263a3ab6cc2a0919cb505.svg";
export { ForwardRef as ReactComponent };